import { Tag } from "@synthesis/shared-ui";

import { CONSTRUCTOR_SERVICE_STATUS_TAG, type ConstructorServiceStatus } from "../constructor-services-page.lib";

/** Бейдж статуса услуги: «Активна» (зелёный) / «Недоступно» (серый), 32px. */
export const ServiceStatusTag = ({ status }: { status: ConstructorServiceStatus }) => {
  const { tagStatus, label, withLeftIcon } = CONSTRUCTOR_SERVICE_STATUS_TAG[status];

  return (
    <Tag
      size="status"
      status={tagStatus}
      leftIcon={withLeftIcon ? <span className="size-2.5 rounded-full bg-current" aria-hidden /> : undefined}
      data-testid={`eacd-service-status-${status.toLowerCase()}`}
    >
      {label}
    </Tag>
  );
};
